import { useSelector } from 'react-redux';
import { checkCompanyModuleRight } from '../helper';
import { useComponent } from '../../Pages/UserSetting/UsersLibrary/UserRights';

interface CostingAccessState {
  Users?: { logInRights?: unknown };
  UserDetails?: { isCompanyAdminLoggedIn?: boolean };
  CompanyRightsReducer?: { companyRightsData?: Record<string, boolean> };
}

/**
 * Whether the logged-in user may see Product Costing data.
 *
 * Two layers must both allow it, matching the development order navigation: the company must hold
 * the Product Costing module, and the user's group must have the Products → Costing right switched
 * on. A company admin passes the second check regardless of group rights.
 *
 * Evaluated on every render because the user's rights are fetched after the app mounts; callers
 * should hide rather than cache, so the result corrects itself once the rights arrive.
 * @returns true when costing data and costing-derived columns may be shown
 */
export const useCostingAccess = (): boolean => {
  const logInRights = useSelector((state: CostingAccessState) => state.Users?.logInRights);
  const isCompanyAdminLoggedIn = useSelector((state: CostingAccessState) => Boolean(state.UserDetails?.isCompanyAdminLoggedIn));
  const companyRightsData = useSelector((state: CostingAccessState) => state.CompanyRightsReducer?.companyRightsData);
  const { CheckModulePermission } = useComponent();

  return checkCompanyModuleRight(companyRightsData ?? {}, 'productCosting') && Boolean(CheckModulePermission(logInRights, 'products', 'costing', isCompanyAdminLoggedIn));
};
